import { render, staticRenderFns } from "./TeachingPlanDown.vue?vue&type=template&id=149cdd4b&scoped=true&"
import script from "./TeachingPlanDown.vue?vue&type=script&lang=js&"
export * from "./TeachingPlanDown.vue?vue&type=script&lang=js&"
import style0 from "./TeachingPlanDown.vue?vue&type=style&index=0&id=149cdd4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149cdd4b",
  null
  
)

export default component.exports